import { LocationNumbersService } from '../../../services'

const editVerifiedCallerId = async function ({ dispatch, state }, payload) {
  const { locationId } = payload

  try {
    const data = await LocationNumbersService.updateVerifiedCallerId(payload)

    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchCallerIDs', {
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default editVerifiedCallerId
